<template>
    <div class="scroll-list">
        <div class="scroll-list__hl-wrapper" v-stick-in-parent>
            <ul class="scroll-list__headline">
                <li v-for="item in items" class="scroll-list__nav-item" :data-uuid="item.uuid"
                    :class="{ 'scroll-list__nav-item--active' : activeId === item.uuid }">
                    <a @click="scrollTo(item.uuid)">{{ item.title }}</a>
                </li>
            </ul>
        </div>
        <template>
            <div class="scroll-list__content" :id="item.uuid" v-for="item in items">
                <slot :name="'slot' + item.uuid"></slot>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    data()
    {
        return {
            activeId: 0,
            activeItems: [],
            // intersectionObserver options
            OPTIONS: {
                root: null, // default, use viewport.
                rootMargin: "-20% 0px -70% 0px", // tried to trigger intersection in second fifth of the viewport
                threshold: 0
            },
            itemsData: Array,
            isScrolled: false
        };
    },

    props: {
        items: Array
    },

    created()
    {
        this.itemsData = this.items;
    },

    mounted()
    {
        if (App.isShopBuilder)
        {
            this.activeItems = this.itemsData.map(i => i.uuid);
        }

        this.$nextTick(() =>
        {
            if (this.itemsData.length > 0)
            {
                this.activeId = this.itemsData[0].uuid;
            }

            let that = this;

            window.addEventListener("scroll", function()
            {
                let el = document.querySelector(".scroll-list-widget");
                if(el !== null){
                    let top = el.offsetTop;
                    let left = el.offsetLeft;
                    let width = el.offsetWidth;
                    let height = el.offsetHeight;

                    while(el.offsetParent) {
                        el = el.offsetParent;
                        top += el.offsetTop;
                        left += el.offsetLeft;
                    }

                    let scrollListWidgetVisible =
                        top < (window.pageYOffset + window.innerHeight) &&
                        left < (window.pageXOffset + window.innerWidth) &&
                        (top + height) > window.pageYOffset &&
                        (left + width) > window.pageXOffset;

                    if(scrollListWidgetVisible && !that.isScrolled){
                        that.isScrolled = true;
                        that.registerIntersectionObserver();
                    }
                }
            });

        });
    },

    computed: {
        renderItems()
        {
            return this.itemsData.filter(i => this.activeItems.includes(i.uuid));
        }
    },

    methods: {
        scrollTo(uuid)
        {
            document.dispatchEvent(new CustomEvent("toggle-details-lazy-load"));

            $("html, body").animate({
                scrollTop: $("#" + uuid).offset().top - $(".header__wrapper").outerHeight() - 90
            }, 800);

            this.activeId = uuid;

            setTimeout(() => {
                document.dispatchEvent(new CustomEvent("toggle-details-lazy-load"));
            }, 800);
        },

        handleIntersection(domNode)
        {
            this.activeId = domNode.id;
        },

        registerIntersectionObserver()
        {
            if ("IntersectionObserver" in window)
            {
                // create Observer
                let scrollListObserver = new IntersectionObserver((entries =>
                {
                    entries.forEach(entry =>
                    {
                        if (entry.isIntersecting)
                        {
                            const el = entry.target;
                            this.handleIntersection(el);
                        }
                    });
                }), this.OPTIONS);

                // iterate over all vnodes inside the default slot.
                const scrollListContents = document.getElementsByClassName("scroll-list__content");
                scrollListContents.forEach(vnode => {
                        // only apply it to nodes that have actual content inside
                        if (vnode.textContent !== ""){
                            // apply intersectionObserver for the DOMelement referenced in the vnode
                            scrollListObserver.observe(vnode);
                        }else{
                            let id = vnode.id;
                            vnode.remove();
                            document.querySelector(".scroll-list__nav-item[data-uuid='"+id+"']").remove();
                        }
                    }
                )

            }
            else
            {
                console.warn("no intersection Observer found - scrollspy not available");
            }

        }
    }
};
</script>
